import { View } from "@react-pdf/renderer";
import { ResumePDFText, ResumePDFHighlightableText } from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import { TemplateSixPDFSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  summary: string;
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateSixPDFSection themeColor={themeColor} heading={heading}>
      <View wrap={false}>{summary && ((enableHighlight || enableMistakeHighlight) ? (
        <ResumePDFHighlightableText
          text={summary}
          section="profile"
          itemIndex={null}
          enableMistakeHighlight={enableMistakeHighlight}
        />
      ) : (
        <ResumePDFText>{summary}</ResumePDFText>
      ))}</View>
    </TemplateSixPDFSection>
  );
};
